import './applied_tags_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostTagsView extends Monitoring.Views.SocialContents.Filters.AppliedTagsView

  removeFilter: (value, list) ->
    @searchQuery.removePostPrimaryTag(value)   if list == @withPrefix('primary_elements')
    @searchQuery.removePostSecondaryTag(value) if list == @withPrefix('secondary_elements')
    @searchQuery.removePostExcludedTag(value)  if list == @withPrefix('excluded_elements')

  withPrefix: (search_query_field) ->
    "post_#{search_query_field}"
